const SmsAnalytics = require("./analytics/analyticIndex").SmsAnalytics;

window.addEventListener("load", () => {
    const smsAnalytics = new SmsAnalytics();
    smsAnalytics.collect();
});
window.aCustomAnalyticsTrigger = true;
